import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

export type MobileCountryCode = {
  id?: number;
  country_code: string;
  mobile_country_code: string;
  regex_pattern?: string;
};

const initialState: MobileCountryCode[] = [];

const mobileCountryCodeSlice = createSlice({
  name: "mobileCountryCode",
  initialState,
  reducers: {
    setMobileCountryCode(_state, action: PayloadAction<MobileCountryCode[]>) {
      return action.payload;
    },
  },
});

export const { setMobileCountryCode } = mobileCountryCodeSlice.actions;

export default mobileCountryCodeSlice.reducer;
